import { Cookie } from './cookies';

export const removeUnioneToken = (): Promise<boolean> => new Promise((resolve, reject) => {
  try {
    Cookie.remove('_s3_support_utid');
    Cookie.remove('_s3_utid');

    Cookie.remove('_support_utid');
    Cookie.remove('_utid');

    resolve(!!Cookie.get('_utid'));
  } catch (error) {
    console.error(error);
    reject(error);
  }
});
